import { Severities, Variants } from '../core/Alert'
import { OsModalProps } from '../core/Modal'

export function getAlertIconAndButtonColors(theme, variant: Variants, severities: Severities) {
  if (variant === 'filled') {
    return theme.palette.white
  } else {
    switch (severities) {
      case 'info':
        return theme.palette.blue[1000]
      case 'success':
        return theme.palette.green[1000]
      case 'warning':
        return theme.palette.orange[1000]
      case 'error':
        return theme.palette.red[1000]
      default:
        return theme.palette.white
    }
  }
}

export function getModalMaxWidth(size: OsModalProps['size'], isDesktop: boolean, isTablet: boolean, isMobile: boolean) {
  if (isMobile) {
    switch (size) {
      case 'xSmall':
        return 328
      case 'small':
        return 328
      case 'medium':
        return 'none'
      case 'large':
        return 'none'
    }
  } else if (isTablet) {
    switch (size) {
      case 'xSmall':
        return 400
      case 'small':
        return 480
      case 'medium':
        return 584
      case 'large':
        return 696
    }
  } else if (isDesktop) {
    switch (size) {
      case 'xSmall':
        return 400
      case 'small':
        return 480
      case 'medium':
        return 800
      case 'large':
        return 1280
    }
  }
}

export function getModalSize(size: OsModalProps['size'], isMobile: boolean, modalType: OsModalProps['modalType']) {
  if (modalType === 'onboarding') {
    return 'medium'
  } else {
    if (isMobile) {
      if (size === 'xSmall') {
        return 'small'
      } else if (size === 'large') {
        return 'medium'
      } else {
        return size
      }
    } else {
      return size
    }
  }
}
